import React from 'react';
import { Outlet } from 'react-router-dom';
import DashboardHeader from '../../components/DashboardHeader';
import { useAuth } from '../../context/AuthContext';
import '../../App.css';

function AdminLayout() {
  const { user } = useAuth();

  return (
    <div className="App">
      <DashboardHeader
        userType={(user?.role || 'admin')?.toLowerCase()}
        userName={user?.displayName || 'Admin'}
      />
      <main className="dashboard-content">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <Outlet />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default AdminLayout;
